import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';import eventEnumerators from 'src/modules/event/eventEnumerators';
import moment from 'moment';

export default [
  {
    name: 'eventDateFrom',
    label: i18n('entities.event.fields.eventDateFrom'),
    schema: schemas.date(
      i18n('entities.event.fields.eventDateFrom'),
      {},
    ),
   render: (value) => value && value instanceof Date ? moment(value).format('YY/MM/DD') : value,
  },{
    name: 'eventDateTo',
    label: i18n('entities.event.fields.eventDateTo'),
    schema: schemas.date(
      i18n('entities.event.fields.eventDateTo'),
      {},
    ),
   render: (value) => value && value instanceof Date ? moment(value).format('YY/MM/DD') : value,
  },
  {
    name: 'name',
    label: i18n('entities.event.fields.name'),
    schema: schemas.string(
      i18n('entities.event.fields.name'),
      {
        "required": true,
        "max": 128
      },
    ),
  },

  {
    name: 'eventVisibility',
    label: i18n('entities.event.fields.eventVisibility'),
    schema: schemas.string(
      i18n('entities.event.fields.eventVisibility'),
      {},
    ),
  },
 
  {
    name: 'externalId',
    label: i18n('entities.event.fields.externalId'),
    schema: schemas.integer(
      i18n('entities.event.fields.externalId'),
      {},
    ),
  },
  
  {
    name: 'eventHour',
    label: i18n('entities.event.fields.eventHourShortDescription'),
    schema: schemas.string(
      i18n('entities.event.fields.eventHour'),
      {
        "max": 8
      },
    ),
  },  
  {
    name: 'description',
    label: i18n('entities.event.fields.description'),
    schema: schemas.string(
      i18n('entities.event.fields.description'),
      {
        "max": 5000
      },
    ),
  }, 
  /*
  {
    name: 'eventTimeZone',
    label: i18n('entities.event.fields.eventTimeZone'),
    schema: schemas.relationToOne(
      i18n('entities.event.fields.eventTimeZone'),
      {},
    ),
  },
  */
  {
    name: 'category',
    label: i18n('entities.event.fields.category'),
    schema: schemas.relationToOne(
      i18n('entities.event.fields.category'),
      {},
    ),
  },
  {
    name: 'country',
    label: i18n('entities.event.fields.country'),
    schema: schemas.relationToOne(
      i18n('entities.event.fields.country'),
      {},
    ),
  },
  {
    name: 'place',
    label: i18n('entities.event.fields.place'),
    schema: schemas.relationToOne(
      i18n('entities.event.fields.place'),
      {},
    ),
  },
  {
    name: 'address',
    label: i18n('entities.event.fields.address'),
    schema: schemas.string(
      i18n('entities.event.fields.address'),
      {
        "max": 512
      },
    ),
  }, 
  {
    name: 'classes',
    label: i18n('entities.event.fields.classes'),
    schema: schemas.relationToMany(
      i18n('entities.event.fields.classes'),
      {},
    ),
  },
  {
    name: 'tags',
    label: i18n('entities.event.fields.tags'),
    schema: schemas.relationToMany(
      i18n('entities.event.fields.tags'),
      {},
    ),
  }, 
  {
    name: 'link',
    label: i18n('entities.event.fields.link'),
    schema: schemas.string(
      i18n('entities.event.fields.link'),
      {
        "max": 256
      },
    ),
  },
 
  {
    name: 'eventStatus',
    label: i18n('entities.event.fields.eventStatus'),
    schema: schemas.enumerator(
      i18n('entities.event.fields.eventStatus'),
      {
        "options": eventEnumerators.eventStatus
      },
    ),
  },  
  {
    name: 'eventSource',
    label: i18n('entities.event.fields.eventSource'),
    schema: schemas.string(
      i18n('entities.event.fields.eventSource'),
      {
        "max": 128
      },
    ),
  },
 
  {/*
    name: 'publicSchedule',
    label: i18n('entities.event.fields.publicSchedule'),
    schema: schemas.boolean(
      i18n('entities.event.fields.publicSchedule'),
      {},
    ),
  */},   

  {
    name: 'eventSchedule',
    label: i18n('entities.event.fields.eventSchedule'),
    schema: schemas.json(
      i18n('entities.event.fields.eventSchedule'),      
    ),
    render: (value) => value ? i18n('entities.event.messages.eventScheduleItems', JSON.parse(value).length) : value,
  },
  
  {
    name: 'notes',
    label: i18n('entities.event.fields.notes'),
    schema: schemas.string(
      i18n('entities.event.fields.notes'),
      {
        "max": 512
      },
    ),
  },
  
  {
    name: 'eventContact',
    label: i18n('entities.event.fields.eventContact'),
    schema: schemas.string(
      i18n('entities.event.fields.eventContact'),
      {
        "max": 254
      },
    ),
  },
  
  {
    name: 'resources',
    label: i18n('entities.event.fields.resources'),
    schema: schemas.files(
      i18n('entities.event.fields.resources'),
      {},
    ),
  },  
  {
    name: 'mainImage',
    label: i18n('entities.event.fields.mainImage'),
    schema: schemas.images(
      i18n('entities.event.fields.mainImage'),
      {
        "max": 1
      },
    ),
  },
  {
    name: 'organizerLogo',
    label: i18n('entities.event.fields.organizerLogo'),
    schema: schemas.images(
      i18n('entities.event.fields.organizerLogo'),
      {
        "max": 1
      },
    ),
  },  
  {
    name: 'mainImageExternal',
    label: i18n('entities.event.fields.mainImageExternal'),
    schema: schemas.string(
      i18n('entities.event.fields.mainImageExternal'),
      {
        "max": 256
      },
    ),
  },
  {
    name: 'organizerLogoExternal',
    label: i18n('entities.event.fields.organizerLogoExternal'),
    schema: schemas.string(
      i18n('entities.event.fields.organizerLogoExternal'),
      {
        "max": 256
      },
    ),
  },
];